import React from 'react';
import classNames from 'classnames';

export interface FooterSecondaryProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

const FooterSecondary = ({ children, className, id }: FooterSecondaryProps): JSX.Element => {
  const footerSecondary = classNames(className, 'usa-footer__secondary-section');

  return (
    <div id={id} className={footerSecondary}>
      <div className="grid-container">
        <div className="grid-row grid-gap">{children}</div>
      </div>
    </div>
  );
};

export default FooterSecondary;
